import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import {environment} from "../../environments/environment";


@Injectable({ providedIn: 'root' })
export class TwoFactorAuthApiService {

  constructor(
    private http: HttpClient
  ) { }

  // request2fa(): Observable<Request2FAResponse> {
  //   return this.http.post<Request2FAResponse>( environment.securityUrl + `/otp`, {})
  // }
  //
  // confirm2fa(request: Confirm2FARequest): Observable<Confirm2FAResponse> {
  //   return this.http.post<Confirm2FAResponse>( environment.securityUrl + `/otp/confirm`, request)
  // }

  validate2fa(code: string): Observable<any> {
    return this.http.post<any>( environment.securityUrl + `/otp/verify?code=${code}`, {})
  }

}
